module.exports = __webpack_public_path__ + "img/card-frame-red.32c8a2d0.png";